import React, { useState } from 'react';

const UploadForm = () => {
    const [modeOfUpload, setModeOfUpload] = useState('');
    const [typeOfUpload, setTypeOfUpload] = useState('');
    const [misUploadMode, setMisUploadMode] = useState('');
    const [comment, setComment] = useState('');
    const [file, setFile] = useState(null);
    const [responseMessage, setResponseMessage] = useState('');

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!file) {
            setResponseMessage('Please upload a file.');
            return;
        }

        const exchangeRate = 18; // Approximate ZAR to USD exchange rate (1 USD ≈ 18 ZAR)

        let message = '';

        if (modeOfUpload === 'Update Records') {
            if (typeOfUpload === 'MIS Headcount') {
                const newHireCount = Math.floor(Math.random() * 50) + 1;
                const retirementCount = Math.floor(Math.random() * 20) + 1;
                const transferCount = Math.floor(Math.random() * 30) + 1;
                message = `Upload successful!\nNew Hire count: ${newHireCount}\nRetirement Count: ${retirementCount}\nTransfer count: ${transferCount}`;
            } else if (typeOfUpload === 'Supplementary payments') {
                const standbyCount = Math.floor(Math.random() * 100) + 1;
                const standbyRands = Math.floor(Math.random() * 100000) + 1000;
                const standbyUSD = (standbyRands / exchangeRate).toFixed(2);

                const overtimeCount = Math.floor(Math.random() * 100) + 1;
                const overtimeRands = Math.floor(Math.random() * 100000) + 1000;
                const overtimeUSD = (overtimeRands / exchangeRate).toFixed(2);

                const calloutCount = Math.floor(Math.random() * 100) + 1;
                const calloutRands = Math.floor(Math.random() * 100000) + 1000;
                const calloutUSD = (calloutRands / exchangeRate).toFixed(2);

                const shiftCount = Math.floor(Math.random() * 100) + 1;
                const shiftRands = Math.floor(Math.random() * 100000) + 1000;
                const shiftUSD = (shiftRands / exchangeRate).toFixed(2);

                message = `Upload successful!\nStandby allowance count: ${standbyCount}\nStandby allowance Total: ${standbyRands} Rands / ${standbyUSD} USD\nOvertime pay count: ${overtimeCount}\nOvertime pay Total: ${overtimeRands} Rands / ${overtimeUSD} USD\nCallout payment count: ${calloutCount}\nCallout payment Total: ${calloutRands} Rands / ${calloutUSD} USD\nShift Allowance count: ${shiftCount}\nShift Allowance Total: ${shiftRands} Rands / ${shiftUSD} USD`;
            } else if (typeOfUpload === 'Allowances and Benefits') {
                const canteenCount = Math.floor(Math.random() * 100) + 1;
                const canteenRands = Math.floor(Math.random() * 50000) + 500;
                const canteenUSD = (canteenRands / exchangeRate).toFixed(2);

                const lifestyleCount = Math.floor(Math.random() * 100) + 1;
                const lifestyleRands = Math.floor(Math.random() * 50000) + 500;
                const lifestyleUSD = (lifestyleRands / exchangeRate).toFixed(2);

                const cellphoneCount = Math.floor(Math.random() * 100) + 1;
                const cellphoneRands = Math.floor(Math.random() * 50000) + 500;
                const cellphoneUSD = (cellphoneRands / exchangeRate).toFixed(2);

                const perdiemCount = Math.floor(Math.random() * 100) + 1;
                const perdiemRands = Math.floor(Math.random() * 50000) + 500;
                const perdiemUSD = (perdiemRands / exchangeRate).toFixed(2);

                message = `Upload successful!\nCanteen subsidy count: ${canteenCount} total: ${canteenRands} Rands / ${canteenUSD} USD\nLifestyle benefits count: ${lifestyleCount} total: ${lifestyleRands} Rands / ${lifestyleUSD} USD\nCellphone allowance count: ${cellphoneCount} total: ${cellphoneRands} Rands / ${cellphoneUSD} USD\nPer diem count: ${perdiemCount} total: ${perdiemRands} Rands / ${perdiemUSD} USD`;
            } else {
                message = 'Upload successful!';
            }
        } else {
            message = 'Upload successful!';
        }

        if (comment) {
            message += `\nComment: ${comment}`;
        }

        setResponseMessage(message);

        // Simulate clearing form after success (optional)
        // setModeOfUpload('');
        // setTypeOfUpload('');
        // setMisUploadMode('');
        // setComment('');
        // setFile(null);
    };

    return (
        <form onSubmit={handleSubmit} className="container mt-4">
            <div className="mb-3">
                <label htmlFor="modeOfUpload" className="form-label">Mode of Upload</label>
                <select
                    id="modeOfUpload"
                    className="form-select"
                    value={modeOfUpload}
                    onChange={(e) => setModeOfUpload(e.target.value)}
                    required
                >
                    <option value="">Select Mode</option>
                    <option value="Add New Data">Add New Data</option>
                    <option value="Remove Existing Data">Remove Existing Data</option>
                    <option value="Update Records">Update Records</option>
                </select>
            </div>

            <div className="mb-3">
                <label htmlFor="typeOfUpload" className="form-label">Type of Upload</label>
                <select
                    id="typeOfUpload"
                    className="form-select"
                    value={typeOfUpload}
                    onChange={(e) => setTypeOfUpload(e.target.value)}
                    required
                >
                    <option value="">Select Type</option>
                    <option value="MIS Headcount">MIS Headcount</option>
                    <option value="Job List">Job List</option>
                    <option value="Org Structure">Org Structure</option>
                    <option value="Job Families">Job Families</option>
                    <option value="Salary Benchmark">Salary Benchmark</option>
                    <option value="Supplementary payments">Supplementary payments</option>
                    <option value="Allowances and Benefits">Allowances and Benefits</option>
                </select>
            </div>

            {typeOfUpload === 'MIS Headcount' && (
                <div className="mb-3">
                    <label htmlFor="misUploadMode" className="form-label">MIS Upload Mode</label>
                    <select
                        id="misUploadMode"
                        className="form-select"
                        value={misUploadMode}
                        onChange={(e) => setMisUploadMode(e.target.value)}
                        required
                    >
                        <option value="">Select Mode</option>
                        <option value="Monthly Upload">Monthly Upload</option>
                        <option value="Ad-hoc Upload">Ad-hoc Upload</option>
                    </select>
                </div>
            )}

            <div className="mb-3">
                <label htmlFor="comment" className="form-label">Comment</label>
                <textarea
                    id="comment"
                    className="form-control"
                    rows="3"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                ></textarea>
            </div>

            <div className="mb-3">
                <label htmlFor="uploadFile" className="form-label">Upload File</label>
                <input
                    type="file"
                    id="uploadFile"
                    className="form-control"
                    onChange={handleFileChange}
                    required
                />
            </div>

            <button type="submit" className="btn btn-primary">Submit</button>

            {responseMessage && (
                <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
                    {responseMessage}
                </div>
            )}
        </form>
    );
};

export default UploadForm;